export function MediamarktTermsES() {
  return (
    <article>
      <h1>Términos y condiciones</h1>

      <time dateTime="2024-09-01">September 2024</time>

      <div>
        <h3>1. General</h3>
        <p>
          Jotta AS («Jottacloud») ofrece un servicio de almacenamiento en la
          nube (el «Servicio») que le permite almacenar, realizar copias de
          seguridad, sincronizar y compartir archivos a través de Internet. Los
          presentes términos de servicio (el «Acuerdo»), junto con nuestra
          Política de privacidad, constituyen un contrato legalmente vinculante
          entre Jottacloud y usted como usuario. Las referencias a «nosotros»,
          «nuestro» y «nos» se refieren a Jottacloud, mientras que «usted», «su»
          y «usuario» se refieren al usuario. Al utilizar el Servicio, usted
          acepta los términos de este Acuerdo y se vincula a ellos por voluntad
          propia.
        </p>
        <h3>2. Cuenta de usuario</h3>
        <p>
          Para utilizar el Servicio, debe configurar una cuenta de Jottacloud.
          En la página de descripción de suscripciones y precios de Jottacloud
          se detallan los planes disponibles. Generalmente, los tipos de
          suscripción incluyen una Cuenta Gratuita, una Cuenta Personal para un
          usuario, una Cuenta Personal para varios usuarios y una Cuenta
          Empresarial.
        </p>
        <h3>3. Cuenta Gratuita</h3>
        <p>
          Se ofrece una Cuenta Gratuita que no tiene coste alguno y cuya
          funcionalidad y capacidad de almacenamiento son limitadas. Jottacloud
          también se reserva el derecho de aplicar otras restricciones y mostrar
          anuncios pagados en las Cuentas Gratuitas. Jottacloud puede cancelar
          una Cuenta Gratuita que haya estado inactiva durante un período mínimo
          de un año.
        </p>
        <h3>4. Cuenta Personal (de uno o más usuarios)</h3>
        <p>
          Se ofrece una Cuenta Personal (de uno o más usuarios) exclusivamente
          para uso privado individual, pero no para empresas, organizaciones ni
          entidades similares. Una Cuenta Personal (de uno o más usuarios) no se
          puede utilizar para almacenar datos en un contexto empresarial y la
          capacidad de almacenamiento y las características que ofrece son
          proporcionales al plan de suscripción elegido. Las Cuentas Personales
          incluyen tanto suscripciones para un solo usuario como otras que se
          pueden compartir con hasta cinco usuarios.
        </p>
        <p>
          Una Cuenta Personal (de uno o más usuarios) es una suscripción de pago
          que tiene una duración de uno o doce meses, y luego se renueva
          automáticamente por un nuevo período de suscripción (uno o doce meses)
          a menos que el usuario la cancele antes de que finalice el período de
          suscripción vigente. Cuando se renueva una suscripción, el nuevo cobro
          se realiza automáticamente contra la tarjeta de crédito del usuario.
          Los pagos no son reembolsables, incluso aunque el usuario los cancele.
          El usuario puede cancelar o cambiar su suscripción en cualquier
          momento.
          <p></p>
          Cuando se establece una Cuenta Personal de varios usuarios, se crea
          automáticamente un administrador. El administrador es responsable de
          agregar y mantener la suscripción y sus miembros. El administrador
          identifica a los miembros de la suscripción proporcionando direcciones
          de correo electrónico o números de teléfono móvil para cada miembro.
        </p>
        <p>
          Como administrador, usted es responsable de pagar los importes
          correspondientes por el uso de la suscripción por parte de todos los
          miembros. El administrador de una Cuenta Personal de varios usuarios
          no tiene acceso a los datos almacenados en las cuentas de los demás
          miembros de la misma, a menos que estos se compartan con el
          administrador. Los miembros solo tienen acceso a sus propios archivos,
          a menos que otros miembros hayan compartido archivos con ellos. Los
          miembros pueden compartir datos y archivos con otras personas.
        </p>
        <p>
          Un administrador puede mejorar (agregar espacio de almacenamiento o
          miembros) o degradar (eliminar espacio de almacenamiento o reducir la
          cantidad de miembros) la cuenta, así como modificar el período de
          suscripción, en cualquier momento. El administrador puede cancelar una
          Cuenta Personal de varios usuarios en cualquier momento. Tras la
          cancelación, todos los datos almacenados se eliminarán dentro de los
          90 días posteriores a la fecha de finalización.
        </p>

        <h3>5. Cuenta Empresarial</h3>
        <p>
          Una empresa, organización o individuo puede crear una Cuenta
          Empresarial. Cuando se crea una Cuenta Empresarial, se genera
          automáticamente un administrador para la misma. Este administrador es
          responsable de agregar y mantener la Cuenta Empresarial y sus
          miembros. A las Cuentas Empresariales se aplican los términos
          específicos que figuran en la sección 6 a continuación.
        </p>
        <h3>6. Términos especiales para Cuentas Empresariales</h3>
        <p>
          Si tiene una Cuenta Empresarial, el presente capítulo («Términos
          especiales para Cuentas Empresariales») se aplica a su uso del
          Servicio. Una Cuenta Empresarial la configura un administrador de
          Cuenta Empresarial (el «administrador»), quien elige el tipo de
          suscripción empresarial y agrega miembros personas a la misma (los
          «miembros») creando para ellos cuentas individuales.
        </p>
        <p>
          El administrador identifica a los miembros de la Cuenta Empresarial a
          través de las direcciones de correo electrónico de cada uno de ellos.
          Como administrador, usted es responsable de pagar los importes
          correspondientes por el uso de la Cuenta Empresarial por parte de
          todos los miembros. El administrador tiene control exclusivo sobre la
          gestión de todas las cuentas de los miembros y garantiza que todo uso
          del Servicio cumpla con este Acuerdo y otros reglamentos de
          Jottacloud. Asimismo, es responsabilidad exclusiva del administrador
          garantizar que la capacidad de almacenamiento para los miembros se
          incremente o reduzca según sea necesario. El administrador también es
          responsable de agregar o eliminar cuentas individuales según sea
          necesario. No se puede obtener almacenamiento adicional para Cuentas
          Empresariales.
        </p>
        <p>
          El administrador no tiene acceso a los datos almacenados en las
          cuentas de los demás miembros, a menos que estos se compartan con el
          administrador. El administrador puede leer la actividad en las cuentas
          de los miembros y así identificar los nombres de archivos y carpetas a
          través de los ficheros cargados y otra información sobre la actividad
          de la cuenta. Los miembros solo tienen acceso a sus propios archivos,
          a menos que otros miembros hayan compartido archivos con ellos. Los
          miembros pueden compartir datos y archivos con otras personas. La
          suscripción empresarial se renueva automáticamente mensual o
          anualmente, a elección del administrador. Un administrador puede
          mejorar (agregar espacio de almacenamiento o aumentar la cantidad de
          miembros) o degradar (eliminar espacio de almacenamiento o reducir la
          cantidad de miembros) la cuenta, así como modificar el período de
          suscripción, en cualquier momento. Dichos cambios se aplicarán a
          partir del final del período de suscripción actual. El administrador
          puede cancelar una Cuenta Empresarial en cualquier momento. Tras la
          cancelación, se eliminarán todos los datos almacenados.
        </p>
        <h3>7. Licencia para utilizar el servicio</h3>
        <p>
          Cuando un usuario se ha registrado para obtener una cuenta de acuerdo
          con los términos de la licencia y las instrucciones de Jottacloud,
          Jottacloud le otorga al usuario el derecho a utilizar el Servicio.
        </p>
        <p>
          El usuario solo debe utilizar el Servicio dentro del propósito
          establecido por Jottacloud, con las limitaciones e instrucciones
          expresadas a tal efecto. Jottacloud le otorga una licencia no
          exclusiva, limitada e intransferible para instalar y utilizar el
          Servicio para el propósito especificado. La licencia no puede
          transferirse a otros ni ponerse a disposición de otros más allá de lo
          establecido en este Acuerdo.
        </p>
        <p>
          Con el Servicio puede proporcionarse código fuente propiedad de
          terceros, que estaría sujeto a las licencias de terceros aplicables.
          El Servicio y su estructura, organización, código fuente y
          documentación contienen secretos empresariales.
        </p>
        <p>
          Jottacloud es el único propietario del Servicio y del software
          utilizado para prestar el Servicio, así como de toda la documentación
          relacionada.
        </p>
        <p>
          El Servicio permite al usuario compartir, enviar e intercambiar
          contenido digital con otras personas. El usuario debe contar con todos
          los permisos necesarios para distribuir este contenido digital. Al
          utilizar el Servicio, usted reconoce que Jottacloud no tiene control
          sobre los archivos digitales enviados o utilizados con el Servicio, y
          Jottacloud no se hace responsable del uso, contenido o almacenamiento
          de dichos archivos digitales en modo alguno.
        </p>
        <p>
          Jottacloud cumple con la ley noruega aplicable en todo momento y se
          reserva el derecho de eliminar material o imponer otras restricciones
          que se consideren necesarias para garantizar el cumplimiento de las
          leyes y regulaciones aplicables.
        </p>
        <p>
          Jottacloud se reserva el derecho de realizar comprobaciones de virus y
          puede bloquear la carga de ciertos archivos.
        </p>
        <p>
          El usuario no puede hacer un uso comercial del Servicio, incluyendo,
          entre otros, la venta o distribución del Servicio, el software o su
          documentación a un tercero.
        </p>
        <h3>8. Mejorar y degradar</h3>
        <p>
          Puede pasar de una Cuenta Gratuita a una Cuenta Personal o una
          Suscripción Doméstica siguiendo los procedimientos de adquisición de
          licencias de Jottacloud. De manera similar, puede bajar de una Cuenta
          Personal o una Suscripción Doméstica a una Cuenta Gratuita. Bajar la
          categoría de una cuenta significa cambiar de una Cuenta Personal o
          Suscripción Doméstica a una Cuenta Gratuita.
        </p>
        <p>
          Antes de poder completar dicha degradación, deberá eliminar archivos
          de su Cuenta Personal o Suscripción Doméstica para que la cantidad
          total de datos no supere el límite de almacenamiento vigente de las
          cuentas gratuitas. En cuanto a las Cuentas Familiares, también deberá
          eliminar a todos los demás miembros antes de pasar a una Cuenta
          Individual o a una Cuenta Gratuita.
        </p>
        <h3>9. Renovaciones, terminación y cancelación de suscripciones</h3>
        <p>
          Las suscripciones de las Cuentas Personales, Suscripciones Domésticas
          y Cuentas Empresariales se renuevan automáticamente cuando expira el
          período de suscripción. El usuario puede cancelar la suscripción en
          cualquier momento. Cancelar una suscripción significa que esta no se
          renovará cuando finalice el período de suscripción. Después de que se
          cancele una suscripción, Jottacloud cancelará la cuenta del usuario o
          la degradará a una Cuenta Gratuita. Si la cuenta contiene más datos
          que el límite de almacenamiento actual para Cuentas Gratuitas, todos
          los archivos de la misma se eliminarán durante esta degradación. Puede
          eliminar su cuenta de usuario en cualquier momento a través de la
          sección de Configuración, en la página «Cuenta y perfil». Si el
          usuario no paga las tarifas u otros importes adeudados a Jottacloud,
          Jottacloud tiene derecho a cancelar la cuenta 90 días después de la
          fecha original de pago. Jottacloud puede rescindir una suscripción
          cancelada sobre esta base después de un período de notificación, lo
          que comporta la eliminación de los archivos y los datos. Jottacloud
          tiene derecho a cancelar la cuenta del usuario si este actúa de una
          manera que vulnere este Acuerdo o las instrucciones impartidas por
          Jottacloud. Eliminaremos los datos del usuario dentro de los 90 días
          posteriores a la cancelación de la cuenta del usuario.
        </p>
        <h3>10. Requisito de edad</h3>
        <p>
          La edad mínima para crear una Cuenta Gratuita, Individual o Familiar
          es de 13 años. Jottacloud tiene derecho a eliminar toda la
          información, incluyendo la cuenta de usuario, los datos y los archivos
          contenidos en la misma, si descubre que el usuario que creó la cuenta
          tiene menos de 13 años. Para Cuentas Familiares, el Administrador
          Familiar debe ser mayor de 13 años.
        </p>
        <h3>11. Cambios en la información personal</h3>
        <p>
          El usuario debe notificar a Jottacloud de los cambios en su dirección
          de correo electrónico e información de pago inmediatamente
          actualizando los datos de la cuenta en la sección de Configuración. El
          usuario es el único responsable de los costes que puedan surgir por la
          ausencia de información del usuario o la incompletitud de esta.
        </p>
        <h3>12. Privacidad y recopilación de datos</h3>
        <p>
          Jottacloud puede recopilar información de identificación no personal
          relacionada con el uso del Servicio. Esto incluye estadísticas y
          mediciones de rendimiento relacionadas con el software. Esta
          información se envía a Jottacloud, quien solo puede utilizarla según
          lo establecido en la Política de privacidad de Jottacloud. Si existe
          un mandato judicial válido de un tribunal noruego, Jottacloud
          divulgará los datos de acuerdo con dicho mandato. En tal caso,
          Jottacloud notificará al usuario si le está legalmente permitido
          hacerlo.
        </p>
        <h3>13. Almacenamiento adicional</h3>
        <p>
          Puede ganar espacio de almacenamiento gratuito adicional
          («Almacenamiento adicional») en su cuenta. El Almacenamiento adicional
          es espacio de almacenamiento gratuito disponible en su cuenta de
          usuario durante un período limitado. Este tipo de almacenamiento solo
          está disponible para Cuentas Gratuitas y Cuentas Individuales.
          Jottacloud se reserva el derecho de cancelar o cambiar los términos
          del Almacenamiento adicional.
        </p>
        <h3>14. Requisitos para utilizar el servicio</h3>
        <p>
          Para utilizar el Servicio, debe tener un ordenador y/o dispositivo
          móvil compatible con acceso a Internet. Utilizar el Servicio a través
          de una conexión inalámbrica puede generar costos adicionales por parte
          de su operador celular/de telefonía móvil. Usted es responsable de
          pagar todos los costes relacionados con los datos y el uso de todos
          los equipos y otros servicios de terceros que utilice para acceder al
          Servicio.
        </p>
        <p>
          El usuario es responsable de recordar su contraseña y mantener su
          confidencialidad. El usuario es responsable de cualquier actividad que
          ocurra bajo su nombre de usuario. Si el usuario pierde la contraseña
          de su cuenta, corre el riesgo de no poder acceder a sus datos. El
          nombre de usuario y la contraseña del usuario son personales y no
          pueden compartirse con terceros. Si el usuario tiene conocimiento de
          un uso indebido de su cuenta, deberá notificarlo a Jottacloud
          inmediatamente.
        </p>
        <h3>15. Uso justo y aceptable</h3>
        <p>
          Todo uso de los productos y servicios de Jottacloud debe cumplir con
          los principios descritos en este Acuerdo y las leyes y regulaciones
          aplicables. Jottacloud podrá establecer o ampliar rutinas operativas
          para garantizar la disponibilidad del Servicio y evitar su uso
          indebido.
        </p>
        <p>
          Como parte de estas rutinas operativas, nos reservamos el derecho de
          monitorear nuestros sistemas para identificar el uso excesivo de
          almacenamiento y recursos de red, así como para implementar aquellas
          medidas técnicas y de otros tipos que consideremos necesarias. Es
          posible que se implementen restricciones en el ancho de banda y en la
          cantidad de llamadas API.
        </p>
        <p>
          La suscripción personal con almacenamiento ilimitado a Jottacloud está
          diseñada para brindar previsibilidad al cliente. «Ilimitado» se
          refiere al espacio de almacenamiento disponible.
        </p>
        <p>
          Los usuarios con una Cuenta Personal o una Suscripción Doméstica
          pueden utilizar el Servicio para un uso normal no empresarial. Nos
          reservamos el derecho de evitar el uso excesivo y el mal uso del
          Servicio.
        </p>
        <p>
          Si el consumo total de almacenamiento y red de un Usuario es
          significativamente mayor que el consumo normal de un usuario promedio
          de Jottacloud, y/o indica que el Servicio se utiliza para un propósito
          distinto al uso personal y no empresarial, puede considerarse un uso
          indebido del servicio.
        </p>
        <p>
          En los casos mencionados anteriormente, nos reservamos el derecho de
          ofrecer una suscripción alternativa a Jottacloud, terminar la relación
          con el cliente o eliminar la cuenta y/o los datos del Usuario. En
          tales casos, comunicaremos al usuario una propuesta de cambio o aviso
          de acción.
        </p>
        <p>
          Los Usuarios no pueden revender cuentas ni ninguno de los servicios de
          la cuenta. No puede compartir su contraseña con terceros y debe
          almacenarla de forma segura y adecuada. Utilizar los servicios y/o
          productos de Jottacloud para actividades ilegales es una violación de
          este Acuerdo.
        </p>
        <p>
          En el Servicio, no puede almacenar ni distribuir datos que violen las
          leyes y regulaciones noruegas, así como las leyes de privacidad y
          derechos de autor. Esto incluye pornografía infantil, material
          pirateado y/u otro material ilegal o protegido por derechos de autor.
        </p>
        <p>
          Se cancelará toda cuenta de usuario utilizada para almacenar y/o
          compartir material ilegal o protegido por derechos de autor en el
          Servicio. Jottacloud se reserva el derecho de bloquear el acceso o
          prohibir el uso del Servicio, eliminar datos del usuario y/o eliminar
          cuentas de usuario si consideramos que el Usuario está violando este
          Acuerdo.
        </p>
        <p>
          El almacenamiento y/o distribución de datos que viole la ley noruega
          puede ser denunciado a las autoridades.
        </p>
        <h3>16. Responsabilidad y garantías</h3>
        <p>
          La responsabilidad total de Jottacloud por cualquier tipo de daño,
          coste o pérdida relacionada con el Servicio, incluyendo la pérdida de
          datos, se limita en cualquier caso a un importe equivalente al
          satisfecho por la cuenta correspondiente en los últimos 12 meses antes
          de la reclamación. Jottacloud no es responsable de ningún tipo de
          pérdida indirecta o consecuente. Estas limitaciones son acordadas por
          las partes y se aplicarán a menos que las disposiciones legales
          vinculantes exijan lo contrario.
        </p>
        <h3>17. Marketing y comunicación en canales electrónicos</h3>
        <p>
          Jottacloud solo enviará al usuario información relevante y
          personalizada sobre novedades, productos y servicios de la empresa en
          canales como correo electrónico y SMS si el usuario ha dado su
          consentimiento a tal efecto. El usuario puede retirar dicho
          consentimiento en cualquier momento.
        </p>
        <h3>18. Cambios en el servicio y términos de uso</h3>
        <p>
          Jottacloud se reserva el derecho de cambiar los términos y condiciones
          del Acuerdo con un aviso de 30 (treinta) días. Jottacloud también se
          reserva el derecho de interrumpir, cambiar o cancelar el Servicio,
          total o parcialmente, después de notificar al usuario por correo
          electrónico al menos 30 (treinta) días antes de dicho cambio o
          cancelación del Servicio. Jottacloud se reserva el derecho de cambiar
          los precios de las suscripciones en curso. Los cambios entrarán en
          vigor 30 (treinta) días después del envío de la notificación. Todos
          los avisos de cambios mencionados anteriormente se enviarán al usuario
          por correo electrónico.
        </p>
        <h3>19. Derecho de desistimiento</h3>
        <p>
          El usuario dispone de un plazo de 14 (catorce) días después de la
          compra del Servicio para cancelar el Servicio sin más obligaciones
          para el usuario. El derecho de desistimiento solo está disponible para
          Cuentas Personales.
        </p>
        <h3>20. Miscelánea</h3>
        <p>
          Jottacloud se reserva el derecho de transferir este Acuerdo a un
          tercero. Jottacloud notificará a los usuarios de dicho cambio. El
          usuario será notificado con 3 (tres) días de antelación vía correo
          electrónico.
        </p>
        <h3>21. Ley aplicable y resolución de disputas</h3>
        <p>
          Este Acuerdo se rige e interpreta de acuerdo con la ley noruega. Las
          partes acuerdan el tribunal de distrito de Oslo como el tribunal de
          referencia
        </p>
        <h3>22. Atención al cliente</h3>
        <p>
          Si tiene preguntas sobre el Servicio, comuníquese con el servicio de
          atención al cliente por correo electrónico en support@jottacloud.com.
          Jottacloud intentará responder a todas las consultas dentro de un
          plazo razonable.
        </p>
        <h3>23. Información de contacto</h3>
        <p>Correo electrónico: support@jottacloud.com</p>
        <p>Jotta AS Øvre Slottsgate 5</p>
      </div>
    </article>
  )
}
